import React from 'react';
import { R } from '@leverege/value-resolver';
import { Attributes } from '@leverege/ui-attributes';
import { SwatchAndColor, AlertPopup, TagIdPopUp } from '../vehicle';
import LocatorStatus from '../sale/LocatorStatus';
import SaleVoidedBy from '../sale/SaleVoidedBy';
import Type from '../sale/Type';
import LinkCellRenderer from '../../../attributes/renderers/table/LinkCell';
import OperationState from '../locator/OperationState';
import OperationStateChangeStatus from '../locator/OperationStateChangeStatus';
import FirmwareStatus from '../fota/FirmwareStatus';
import ResetRequestState from '../locator/ResetRequestState';
import AutoLocationTransferZone from '../locator/AutoLocationTransferZone';
import SaleState from '../sale/SaleState';
import LocatorVehicleLink from './LocatorVehicleLink';
import ContractState from '../contract/ContractState';
import { BillStateValue, AddendumChargesRenderer, AddendumCreditsRenderer } from '../billing';
import ReconciliationStatus from '../sale/ReconciliationStatus';
import { alertLabels, alertVariants } from '../../attributes/CalculatedAlerts';
import { RecovrProductsSold } from '../sale';
import DeviceLocationLink from './DeviceLocationLink';
import createAlertVariant from '../Util';
export default {
  install(molten) {
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.swatchAndColor',
      renderer: (value, valueStyle, object, _context) => {
        return /*#__PURE__*/React.createElement(SwatchAndColor, {
          value: Array.isArray(value) ? value[0] : null,
          object,
          style: valueStyle
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.calculatedAlerts',
      renderer: (value, _style, _object, context) => {
        const vin = context?.target?.[0]?.data?.data?.vin;
        if (value) {
          const style = {
            justifyContent: 'flex-end',
            paddingRight: '16px'
          };
          return /*#__PURE__*/React.createElement(AlertPopup, {
            value: Array.isArray(value) && value[0]?.length > 0 ? value[0]?.split?.(',') : null,
            vin,
            alertLabels: R(alertLabels),
            alertVariants,
            defaultFirstPillVariant: 'pillError',
            defaultLastPillVariant: 'pillError',
            style
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.dtcAlerts',
      renderer: (_value, _style, object, context) => {
        const dtcs = object?.data?.data?.obdTracker?.data?.dtcs || {};
        const dtcsArray = Object.keys(dtcs);
        const vin = context?.target?.[0]?.data?.data?.vin;
        return /*#__PURE__*/React.createElement(AlertPopup, {
          value: dtcsArray,
          vin,
          defaultFirstPillVariant: 'pillDTC',
          defaultLastPillVariant: 'pillWarning'
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'locator',
      attrName: 'locator.operationStateChangeStatus',
      renderer: (value, _style, _object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(OperationStateChangeStatus, {
            value: Array.isArray(value) ? value[0] : null
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'locator',
      attrName: 'locator.firmware.status',
      renderer: (value, _style, _object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(FirmwareStatus, {
            value: Array.isArray(value) ? value[0] : null
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'sale',
      attrName: 'sale.voidedBy',
      renderer: (data, props, context) => {
        return /*#__PURE__*/React.createElement(SaleVoidedBy, {
          original: data.row?.original,
          context,
          ...props
        });
      },
      handles: () => true
    });

    // sale stuff
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'sale',
      attrName: 'sale.locator.status',
      renderer: (value, _style, _object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(LocatorStatus, {
            value: Array.isArray(value) ? value[0] : null
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'sale',
      attrName: 'sale.state',
      renderer: (value, _style, _object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(SaleState, {
            value: Array.isArray(value) ? value[0] : null
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'locator',
      attrName: 'locator.events.resetRequestState',
      renderer: (value, _style, _object, _context) => {
        if (value != null) {
          return /*#__PURE__*/React.createElement(ResetRequestState, {
            value: Array.isArray(value) ? value[0] : null,
            isDetail: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'locator',
      attrName: 'locator.desiredOperationState',
      renderer: (value, _style, _object, _context) => {
        if (value != null) {
          return /*#__PURE__*/React.createElement(OperationState, {
            value: Array.isArray(value) ? value[0] : null,
            isDetail: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.locator$locator.desiredOperationState',
      renderer: (value, _style, _object, _context) => {
        if (value != null) {
          return /*#__PURE__*/React.createElement(OperationState, {
            value: Array.isArray(value) ? value[0] : null,
            isDetail: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.locator$locator.zone.name',
      renderer: (value, _style, object, _context) => {
        if (value != null) {
          return /*#__PURE__*/React.createElement(AutoLocationTransferZone, {
            value,
            object,
            isDetail: true,
            isVehicle: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'locator',
      attrName: 'locator.zone.name',
      renderer: (value, _style, object, _context) => {
        if (value != null) {
          return /*#__PURE__*/React.createElement(AutoLocationTransferZone, {
            value,
            object,
            isDetail: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'locator',
      attrName: 'locator.reportedOperationState',
      renderer: (value, _style, _object, _context) => {
        if (value != null) {
          return /*#__PURE__*/React.createElement(OperationState, {
            value: Array.isArray(value) ? value[0] : null,
            isDetail: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.locator$locator.reportedOperationState',
      renderer: (value, _style, _object, _context) => {
        if (value != null) {
          return /*#__PURE__*/React.createElement(OperationState, {
            value: Array.isArray(value) ? value[0] : null,
            isDetail: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'sale',
      attrName: 'sale.type',
      renderer: (value, _style, _object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(Type, {
            value: Array.isArray(value) ? value[0] : null
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'locator',
      attrName: 'locator.businessState',
      renderer: (value, _style, _object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(LocatorStatus, {
            value: Array.isArray(value) ? value[0] : null
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'companyContract',
      attrName: 'companyContract.calculatedContractState',
      renderer: (value, _style, object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(ContractState, {
            value: Array.isArray(value) ? value[0] : null,
            object
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'bill',
      attrName: 'bill.sellThroughRate',
      renderer: (value, _style, object, context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(BillStateValue, {
            value,
            context,
            object
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'bill',
      attrName: 'bill.totalCharges',
      renderer: (_value, _style, object, context) => {
        return /*#__PURE__*/React.createElement(AddendumChargesRenderer, {
          original: object,
          context
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'bill',
      attrName: 'bill.totalCredits',
      renderer: (_value, _style, object, context) => {
        return /*#__PURE__*/React.createElement(AddendumCreditsRenderer, {
          original: object,
          context
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      id: 'recovr.renderer.detail.locatorVehicleLink',
      objectType: 'locator',
      attrName: 'locator.vehicleId',
      renderer: (value, _style, object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(LocatorVehicleLink, {
            value: Array.isArray(value) ? value[0] : null,
            object
          });
        }
        return null;
      }
    });
    const objectTypes = ['vehicle', 'locator'];
    objectTypes.forEach(objectType => {
      molten.addPlugin('AttributeValueRenderer', {
        id: `recovr.renderer.detail.${objectType}LocationLink`,
        objectType,
        attrName: `${objectType}.locationId`,
        renderer: (value, _style, object, _context) => {
          if (value) {
            return /*#__PURE__*/React.createElement(DeviceLocationLink, {
              value: Array.isArray(value) ? value[0] : null,
              object
            });
          }
          return null;
        }
      });
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'sale',
      attrName: 'sale.reconciliation.status',
      renderer: (value, _style, _object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(ReconciliationStatus, {
            value: Array.isArray(value) ? value[0] : null
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'sale',
      attrName: 'sale.recovrProductsSold',
      renderer: (_data, _style, object, context) => {
        return /*#__PURE__*/React.createElement(RecovrProductsSold, {
          original: object,
          context,
          value: Attributes.get('sale.recovrProductsSold', 'sale', object.data)
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'sale',
      attrName: 'sale.tagIds',
      renderer: (_data, _style, object, _context) => {
        const vin = object.data?.data?.vehicle?.vin;
        const tagId = Attributes.get('sale.tagIds', 'sale', object.data);
        const alertVariants = tagId ? tagId.map(value => createAlertVariant(object.data?.data?.keys, value)) : [];
        return /*#__PURE__*/React.createElement(TagIdPopUp, {
          value: Attributes.get('sale.tagIds', 'sale', object.data),
          vin,
          alertVariants,
          style: {
            justifyContent: 'flex-end',
            paddingRight: '16px'
          }
        });
      },
      handles: () => true
    });
  }
};